<template>
  <Transition name="cookie-slide">
    <div v-if="showBanner" class="cookie-banner" role="dialog" aria-label="Cookie-Einstellungen">
      <div class="cookie-inner">
        <div class="cookie-text">
          <div class="cookie-icon">🍪</div>
          <div class="cookie-copy">
            <strong>Diese Website verwendet Cookies</strong>
            <p>
              Wir nutzen Cookies, um die Funktionalität der Website sicherzustellen und Ihr Erlebnis
              zu verbessern. Details finden Sie in unserer
              <router-link to="/datenschutz">Datenschutzerklärung</router-link>.
            </p>
          </div>
        </div>
        <div class="cookie-actions">
          <button class="cookie-btn-decline" @click="decline">Ablehnen</button>
          <button class="cookie-btn-accept" @click="accept">Akzeptieren</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return { showBanner: false };
  },
  mounted() {
    if (!localStorage.getItem('cookie-consent')) {
      setTimeout(() => { this.showBanner = true; }, 700);
    }
  },
  methods: {
    accept() {
      localStorage.setItem('cookie-consent', 'accepted');
      this.showBanner = false;
    },
    decline() {
      localStorage.setItem('cookie-consent', 'declined');
      this.showBanner = false;
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: rgba(13, 13, 26, 0.97);
  backdrop-filter: blur(24px);
  border-top: 1px solid rgba(102, 126, 234, 0.25);
  padding: 18px 24px;
  box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.3);
}

.cookie-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 32px;
  justify-content: space-between;
}

.cookie-text {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex: 1;
}

.cookie-icon {
  font-size: 26px;
  flex-shrink: 0;
  margin-top: 1px;
  line-height: 1;
}

.cookie-copy strong {
  display: block;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 3px;
}

.cookie-copy p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
}

.cookie-copy a {
  color: #667eea;
  text-decoration: underline;
  text-decoration-thickness: 1px;
}

.cookie-copy a:hover {
  color: #764ba2;
}

.cookie-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.cookie-btn-decline {
  padding: 10px 20px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.cookie-btn-decline:hover {
  border-color: rgba(255, 255, 255, 0.4);
  color: #fff;
  background: rgba(255, 255, 255, 0.06);
}

.cookie-btn-accept {
  padding: 10px 24px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  white-space: nowrap;
}

.cookie-btn-accept:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 22px rgba(102, 126, 234, 0.55);
}

/* Transition */
.cookie-slide-enter-active,
.cookie-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease;
}

.cookie-slide-enter-from,
.cookie-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* Mobile */
@media (max-width: 640px) {
  .cookie-banner { padding: 16px; }

  .cookie-inner {
    flex-direction: column;
    gap: 14px;
    align-items: stretch;
  }

  .cookie-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .cookie-btn-decline,
  .cookie-btn-accept {
    text-align: center;
    justify-content: center;
  }
}
</style>
